const getElementsLimitDepth = (element, maxDepth, currentDepth = 1) => {
  if (currentDepth > maxDepth) return []

  const results = Array.from(element.children).filter(
    elem =>
      !(
        elem.tagName === 'NOSCRIPT' ||
        elem.tagName === 'SCRIPT' ||
        elem.tagName === 'STYLE' ||
        elem.classList.contains('universal-search-outer') ||
        elem.classList.contains('universal-search')
      )
  )
  for (const child of element.children) {
    if (
      !(
        child.classList.contains('universal-search-outer') ||
        child.classList.contains('universal-search')
      )
    )
      results.push(...getElementsLimitDepth(child, maxDepth, currentDepth + 1))
  }
  return results
}

export const getFixedAndStickyHeight = maxTop => {
  let totalHeight = 0
  const allElements = getElementsLimitDepth(document.body, 5)

  allElements.forEach(element => {
    const computedStyle = window.getComputedStyle(element)
    const elementPosition = computedStyle.position

    if (elementPosition === 'fixed' || elementPosition === 'sticky') {
      // Only calculate height of elements that are less than the viewport maxTop passed in (default to 50 ie "near the top")
      // and are actually visible (offsetHeight > 0)
      const rect = element.getBoundingClientRect()
      if (
        element.offsetHeight > 0 &&
        element.checkVisibility({ opacityProperty: true }) &&
        rect.top >= 0 &&
        rect.top < (maxTop || 50)
      ) {
        totalHeight += element.offsetHeight
      }
    }
  })

  return totalHeight
}
